export const RESET = 'TERRITORY_LIST_RESET'
export const SET_ITEMS = 'TERRITORY_LIST_SET_ITEMS'
export const SET_ERROR = 'TERRITORY_LIST_SET_ERROR'
export const SET_VIEW = 'TERRITORY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'TERRITORY_LIST_TOGGLE_LOADING'
